module.exports = __webpack_public_path__ + "img/oee-1.18efd527.png";